import {RemovalZoneForm} from "./RemovalZoneForm";
import {PopupForm, PopupFormAction} from "@tracabois/components";
import {useCallback, useState} from "react";
import {RemovalZoneCreateCommand} from "../../model/removalZone";
import {useFormComposable} from "@komune-io/g2-composable";
import {WoodSpecies} from "../../../../referentiels/woodSpecies";
import {PlatformSectionForm} from "@tracabois/template/src/platform/PlatformSectionForm";
import { Department, useDropZonePicture } from "@tracabois/domain";
import { Commune } from "../../../../referentiels/commune";
import { RemovalZoneCertification } from "../../../../referentiels/removalZoneCertification";

export interface RemovalZoneFormPopupProps {
  open: boolean
  onCancel: () => void;
  woodSpecies: WoodSpecies[],
  departments: Department[],
  communes: Commune[],
  removalZoneCertifications: RemovalZoneCertification[],
  actor?: string
  onCreate: (item: RemovalZoneCreateCommand) => Promise<boolean> | boolean

}

export const RemovalZoneCreateFormPopup = (props: RemovalZoneFormPopupProps) => {
  const {open, onCreate, woodSpecies, departments, communes, removalZoneCertifications, onCancel, actor} = props
  const [feedback, setFeedback] = useState<boolean | undefined>(undefined)
  const imageDropZone = useDropZonePicture()
  const onSubmitMemoized = useCallback(
    async (values: RemovalZoneCreateCommand) => {
      const result = await onCreate({
        ...values,
        img: imageDropZone.pictureUrl,
      }) || false
      setFeedback(result)
      return result
    },
    [onCreate, imageDropZone.pictureUrl]
  )

  const formState = useFormComposable<RemovalZoneCreateCommand>({
    onSubmit: onSubmitMemoized,
    actions: {
      validate: {
        label: "Créer",
      },
      cancel: {
        onClick: onCancel,
      }
    },
    formikConfig: {
      initialValues: {
        organization: actor ? {id: actor} : undefined,
      }
    },
  })
  return (
    <PopupForm open={open} onClose={onCancel} title="Création d'une zone d'origine">
      <PlatformSectionForm>
        <RemovalZoneForm
          imageDropZone={imageDropZone}
          formState={formState}
          woodSpecies={woodSpecies}
          departments={departments}
          communes={communes}
          removalZoneCertifications={removalZoneCertifications}
        />
        <PopupFormAction
          formState={formState}
          isCreation
          onCancel={onCancel}
          feedback={feedback}
        />
      </PlatformSectionForm>
    </PopupForm>
  )
};
